export default __webpack_public_path__ + "static/media/horror.e188e932.png";